export const plan = {
  config: [
    {
      id: 'creditsLeft',
      label: 'Credits Left',
      fieldType: 'number',
    },
    {
      id: 'creditsRenewal',
      label: 'Credits Renewal',
      fieldType: 'date',
    },
    {
      id: 'planName',
      label: 'Plan Name',
      fieldType: 'chip',
    },
  ],
};

export const api = {
  config: [
    {
      id: 'clientId',
      label: 'Client Id',
      fieldType: 'copy',
    },
    {
      id: 'clientSecret',
      label: 'Client Secret',
      fieldType: 'copy',
    },
  ],
  values: {
    apiKey: 'sk_test_4eC39HqLyjWDarjtT1zdp7dc',
  },
};
